import AppRoutes from 'src/AppRoutes';

const PageRoot = () => {
   return <AppRoutes />;
};

export default PageRoot;
